import styled from 'styled-components';
export const Checkbox = styled.div`
  cursor: ${props => (props.disabled ? 'inherit' : 'pointer')};
  > i {
    color: ${props =>
      props.disabled ? 'gray' : props.checked ? '#0099A9' : '#90A4AE'};
  }
`;
